export enum PropertyStatus { 
        Available = 0,
        UnderOffer = 1,
        Completed = 2,
        NotAvailable = 3,
        Valuation = 4,
        Archived = 5,
        Instructed = 6,
        BankValuation = 7,
}

